<h2 >Welcome to the HA- Statistics tool</h2>

<p>Hello, here is my statistic tool for the french <a target="_blank" href="https://hybridassistant.blogspot.com/">HA Assistant APP</a>
  <br>
  This Angular Web App use a Restfull API to get the data from the MySQL Database. You can Upload new Files from the App Backend. please read the documentation.
  <br>
  <a href="https://lukas-kraemer.de" target="_blank">Visit my Homepage</a>
</p>
